import type { TRPCClientError } from "@trpc/client";
import { DiamondMinus, X } from "lucide-react";
import { useTaskNavigation } from "@/hooks/useTaskNavigation";
import { Button } from "./ui/button";
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "./ui/empty";

export default function TaskNotFoundFallback({ error }: { error: TRPCClientError<any> }) {
    const { closeTask } = useTaskNavigation();

    const handleClose = () => {
        closeTask();
    };

    if (error.data?.code === "NOT_FOUND") {
        return (
            <div className="h-full">
                <div className="ml-0.5 absolute top-4 right-4">
                    <Button
                        variant="ghost"
                        size="icon"
                        className="text-zinc-600 hover:bg-neutral-200/70"
                        onClick={handleClose}
                    >
                        <X className="size-4" />
                    </Button>
                </div>
                <Empty className="h-full">
                    <EmptyHeader>
                        <EmptyMedia variant="icon" className="bg-red-100/60 text-red-600">
                            <DiamondMinus />
                        </EmptyMedia>
                        <EmptyTitle>Task not found</EmptyTitle>
                        <EmptyDescription>
                            The task you are looking for does not exist, has been deleted, belongs to another workspace
                            or you are not allowed to view it.
                        </EmptyDescription>
                    </EmptyHeader>
                </Empty>
            </div>
        );
    }
}
